import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getFormaPago() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}get-forma-pago`);
    return response

  } catch (error) {
    console.error('Error al obtener las formas de pago', error);
  }
}